import axios, {GenericAbortSignal} from 'axios'
import {checkAuth} from '@utils/helpers'

export const getBalance = async (accessToken?: string) => {
  if (!accessToken) return

  const config = {
    headers: {
      'X-Core-Api-Version': 'v1',
      'Authorization': 'Bearer ' + accessToken,
      'X-Core-Client-Id': process.env.NEXT_PUBLIC_CLIENT_ID,
    },
  }
  const apiUrl = process.env.NEXT_PUBLIC_OIDC + '/accounts/balance'
  const response = await axios.get(apiUrl, config)

  if (response?.data?.code === 0) {
    return response?.data?.data?.balance ? response?.data?.data?.balance : 0
  } else {
    return 0
  }
}

export const getTotalNewMessage = async ({signal}: {signal: GenericAbortSignal}) => {
  if (!checkAuth()) {
    return 0
  }

  const apiUrl = process.env.NEXT_PUBLIC_AFEVENT2 + '/api/get_private_info.php'
  const response = await axios.get(apiUrl, {
    withCredentials: true,
    signal,
  })

  return response?.data?.CHANNEL?.NOTE_NEW ? response?.data?.CHANNEL?.NOTE_NEW : 0
}
